import React from 'react';
import { Form, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';
import { ResponsiveRadioGroup, StyledRadioButton } from './styles';

export function AlarmPercentualVariationFields() {
  const { t } = useTranslation('create-alarm-step');

  return (
    <>
      <Form.Item
        name="percentVariationMeasure"
        label={t(
          'create-alarm-step:stepTwo.createAlarmPercentVariationMeasureField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmPercentVariationMeasureFieldRequired',
            ),
          },
        ]}
      >
        <ResponsiveRadioGroup optionType="button">
          <StyledRadioButton value="perc_min" position="left">
            {t(
              'create-alarm-step:stepTwo.createAlarmPercentVariationMeasureBelowField',
            )}
          </StyledRadioButton>
          <StyledRadioButton value="perc_max" position="right">
            {t(
              'create-alarm-step:stepTwo.createAlarmPercentVariationMeasureAboveField',
            )}
          </StyledRadioButton>
        </ResponsiveRadioGroup>
      </Form.Item>

      <Form.Item
        name="percentVariationPeriod"
        label={t(
          'create-alarm-step:stepTwo.createAlarmPercentVariationMomentField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmPercentVariationMomentFieldRequired',
            ),
          },
        ]}
      >
        <ResponsiveRadioGroup optionType="button">
          <StyledRadioButton value="5m" position="left">
            {t(
              'create-alarm-step:stepTwo.createAlarmpercentVariationMomentMinute',
            )}
          </StyledRadioButton>
          <StyledRadioButton value="24h" position="right">
            {t(
              'create-alarm-step:stepTwo.createAlarmpercentVariationMomentDay',
            )}
          </StyledRadioButton>
        </ResponsiveRadioGroup>
      </Form.Item>

      <Form.Item
        name="percentVariationValue"
        label={t(
          'create-alarm-step:stepTwo.createAlarmPercentVariationValueToTriggerField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmPercentVariationValueToTriggerFieldRequired',
            ),
          },
        ]}
      >
        <InputNumber<number>
          min={0}
          max={100}
          step={0.1}
          formatter={value => `${value}%`}
          parser={value => {
            const cleaned = value?.replace('%', '').replace(',', '.') || '0';
            return parseFloat(cleaned);
          }}
          style={{ width: '100%' }}
        />
      </Form.Item>
    </>
  );
}
